import modalReducer from './modal-reducer';

export default modalReducer;
